import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-rozops-navy text-white/80 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <div className="mb-4 inline-flex rounded-xl bg-white px-3 py-2">
            <img src="/ro-hlogo.png" alt="RozOps" className="h-10 w-auto object-contain" />
          </div>
          <p className="text-sm text-white/60 max-w-sm">Run your everyday business better. Customers, subscriptions, deliveries, bills and payments — one clean place, no notebooks.</p>
        </div>
        <div>
          <div className="text-white font-semibold mb-3">Product</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/features" className="hover:text-white">Features</Link></li>
            <li><Link to="/benefits" className="hover:text-white">Benefits</Link></li>
            <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
            <li><Link to="/how-to-use" className="hover:text-white">How it works</Link></li>
            {/* <li><Link to="/project-info" className="hover:text-white">Project Info</Link></li> */}
          </ul>
        </div>
        <div>
          <div className="text-white font-semibold mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> hello@rozops.com</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> +91-9100507307</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-white/50 flex flex-col md:flex-row justify-between gap-3">
          <div>© {new Date().getFullYear()} RozOps. All rights reserved.</div>
          <div className="flex gap-4"><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy</Link><Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms</Link><Link to="/refund" className="hover:text-white" data-testid="footer-refund">Refund Policy</Link></div>
        </div>
      </div>
    </footer>
  );
}
